import { ChecklistOutlined } from '@mui/icons-material'
import { Button } from '@mui/material'
import { useBomItemIssueDescription } from 'features/BillOfMaterials/components/useBomItemIssueDescription'
import { useBomItemDetailsDialog } from 'features/BomItemDetailsDialog/useBomItemDetailsDialog'
import { BomItemPointer } from 'model/Project/BomItemPointer'
import {
  IssueDto,
  WorkingStepType,
} from 'services/APIs/InternalAPI/internal-api.contracts'

type Props = {
  bomItemPointer: BomItemPointer
  issue: IssueDto
}
export const MaterialOrManualPriceNotSetTodo = (props: Props) => {
  const openDetailsDialog = useBomItemDetailsDialog()
  const { getIssueDescription } = useBomItemIssueDescription()

  const handleOpenPurchasingPartDialog = () => {
    openDetailsDialog('articles', {
      bomItemPointer: props.bomItemPointer,
      workingStep: WorkingStepType.Purchasing,
    })
  }

  return (
    <div>
      <Button
        component="li"
        onClick={handleOpenPurchasingPartDialog}
        color="inherit"
        startIcon={<ChecklistOutlined />}
        style={{
          display: 'flex',
          gap: '1rem',
          alignItems: 'center',
          justifyContent: 'flex-start',
        }}
      >
        {getIssueDescription(props.issue)}
      </Button>
    </div>
  )
}
